// Modern Quiz JavaScript
class Quiz {
    constructor() {
        this.currentQuestion = 0;
        this.answers = {};
        this.quizType = null;
        this.questions = [];
        
        this.init();
    }
    
    init() {
        this.setupQuestions();
        this.bindEvents();
    }
    
    setupQuestions() {
        // All questions in one array - we'll dynamically show based on answers
        this.allQuestions = {
            // First question - determines the path
            product_type: {
                id: 'product_type',
                title: 'What area would you like to focus on?',
                options: [
                    { value: 'hair', label: 'Hair Care' },
                    { value: 'skin', label: 'Skin Care' }
                ]
            },
            
            // Hair questions
            hair_texture: {
                id: 'hair_texture',
                title: 'Your hair texture is:',
                options: [
                    { value: 'Fine', label: 'Fine' },
                    { value: 'Medium', label: 'Medium' },
                    { value: 'Thick', label: 'Thick' }
                ]
            },
            hair_scalp: {
                id: 'hair_scalp',
                title: 'Your scalp is:',
                options: [
                    { value: 'Dry', label: 'Dry' },
                    { value: 'Normal', label: 'Normal' },
                    { value: 'Oily', label: 'Oily' }
                ]
            },
            hair_concern: {
                id: 'hair_concern',
                title: 'What is your biggest concern about your hair?',
                options: [
                    { value: 'Dry/flaky scalp', label: 'Dry/flaky scalp' },
                    { value: 'Hair growth', label: 'Hair growth' },
                    { value: 'Oil control', label: 'Oil control' },
                    { value: 'Weak and brittle hair', label: 'Weak and brittle hair' },
                    { value: 'Frizz', label: 'Frizz' },
                    { value: 'Hair fallout', label: 'Hair fallout' },
                    { value: 'Dryness', label: 'Dryness' },
                    { value: 'My hair\'s in pretty good shape, I\'m looking to keep it that way!', label: 'My hair\'s in pretty good shape, I\'m looking to keep it that way!' }
                ]
            },
            
            // Skin questions
            skin_type: {
                id: 'skin_type',
                title: 'What best describes your skin type?',
                options: [
                    { value: 'Normal', label: 'Normal' },
                    { value: 'Dry', label: 'Dry' },
                    { value: 'Combination', label: 'Combination' },
                    { value: 'Oily', label: 'Oily' }
                ]
            },
            skin_issues: {
                id: 'skin_issues',
                title: 'What issues - if any - do you have with your skin?',
                options: [
                    { value: 'Breakouts', label: 'Breakouts' },
                    { value: 'Fine lines and wrinkles', label: 'Fine lines and wrinkles' },
                    { value: 'Oiliness', label: 'Oiliness' },
                    { value: 'Dryness', label: 'Dryness' },
                    { value: 'Rosacea and/or redness', label: 'Rosacea and/or redness' },
                    { value: 'Acne scars', label: 'Acne scars' },
                    { value: 'Uneven skin tone', label: 'Uneven skin tone' },
                    { value: 'My skin\'s in pretty good shape, I\'m looking to keep it that way!', label: 'My skin\'s in pretty good shape, I\'m looking to keep it that way!' }
                ]
            },
            skin_sensitivity: {
                id: 'skin_sensitivity',
                title: 'Is your skin sensitive to most beauty products?',
                options: [
                    { value: 'Yes', label: 'Yes' },
                    { value: 'No', label: 'No' }
                ]
            }
        };
        
        // Start with the first question
        this.questions = ['product_type'];
    }
    
    
    bindEvents() {
        document.getElementById('start-quiz-btn').addEventListener('click', () => {
            this.startQuiz();
        });
    }
    
    startQuiz() {
        document.getElementById('quiz-start').style.display = 'none';
        document.getElementById('quiz-container').style.display = 'block';
        
        this.showQuestion(0);
    }
    
    showQuestion(index) {
        this.currentQuestion = index;
        const questionKey = this.questions[index];
        const question = this.allQuestions[questionKey];
        
        // Update progress
        const progressText = document.querySelector('.quiz-progress-text');
        if (this.quizType && index > 0) {
            // Show progress starting from question 2 (index 1)
            const currentStep = index; // index 1 = step 1, index 2 = step 2, etc.
            const totalSteps = this.questions.length - 1; // Exclude the first question
            document.getElementById('current-question').textContent = currentStep;
            document.getElementById('total-questions').textContent = totalSteps;
            progressText.style.display = 'block';
            
            const progress = (currentStep / totalSteps) * 100;
            document.getElementById('quiz-progress-fill').style.width = progress + '%';
        } else {
            // Hide progress for the first question
            progressText.style.display = 'none';
            document.getElementById('quiz-progress-fill').style.width = '0%';
        }
        
        // Update question
        document.getElementById('question-title').textContent = question.title;
        
        // Clear and populate options
        const optionsContainer = document.getElementById('question-options');
        optionsContainer.innerHTML = '';
        
        question.options.forEach((option, optionIndex) => {
            const optionElement = document.createElement('div');
            optionElement.className = 'quiz-option';
            optionElement.innerHTML = `
                <input type="radio" id="option-${optionIndex}" name="question-${index}" value="${option.value}">
                <label for="option-${optionIndex}" class="quiz-option-label">
                    ${option.label}
                </label>
            `;
            
            optionElement.addEventListener('click', () => {
                this.selectOption(question.id, option.value);
            });
            
            optionsContainer.appendChild(optionElement);
        });
        
        // Smooth scroll to top of page for questions after the first one
        if (index > 0) {
            window.scrollTo({ 
                top: 0, 
                behavior: 'smooth' 
            });
        }
        
    }
    
    selectOption(questionId, value) {
        // Prevent multiple selections for the same question
        if (this.answers[questionId] !== undefined) {
            return;
        }
        
        this.answers[questionId] = value;
        
        // If this is the first question (product type), set up the rest of the questions
        if (questionId === 'product_type') {
            this.setupQuestionPath(value);
        }
        
        // Auto-advance to next question after a short delay
        setTimeout(() => {
            this.nextQuestion();
        }, 500);
    }
    
    setupQuestionPath(productType) {
        this.quizType = productType; // Set the quiz type
        if (productType === 'hair') {
            this.questions = ['product_type', 'hair_texture', 'hair_scalp', 'hair_concern'];
        } else if (productType === 'skin') {
            this.questions = ['product_type', 'skin_type', 'skin_issues', 'skin_sensitivity'];
        }
    }
    
    nextQuestion() {
        if (this.currentQuestion < this.questions.length - 1) {
            this.showQuestion(this.currentQuestion + 1);
        } else {
            this.showResults();
        }
    }
    
    showResults() {
        // Hide quiz elements
        document.getElementById('question-card').style.display = 'none';
        document.querySelector('.quiz-progress-container').style.display = 'none';
        
        // Show results loading
        document.getElementById('results-loading').style.display = 'block';
        
        // Scroll to top of page
        window.scrollTo({ 
            top: 0, 
            behavior: 'smooth' 
        });
        
        // Calculate recommendation
        const recommendation = this.calculateRecommendation();
        
        // Track Facebook Pixel
        if (typeof fbq !== 'undefined') {
            fbq('track', 'CustomizeProduct');
        }
        
        // Check if this is a hair growth related quiz
        const isHairGrowthRelated = this.isHairGrowthRelated();
        
        // Redirect to appropriate page
        setTimeout(() => {
            let redirectUrl;
            if (isHairGrowthRelated) {
                // Redirect to hair growth page for any hair growth related concerns
                redirectUrl = 'https://allpabotanicals.com/pages/hair-growth-scalp-health';
            } else {
                // Keep existing behavior for other quizzes
                redirectUrl = this.answers.product_type === 'hair' 
                    ? `https://allpabotanicals.com/products/${recommendation}-hair-oil`
                    : `https://allpabotanicals.com/products/${recommendation}-face-oil`;
            }
            
            window.location.href = redirectUrl;
        }, 2000);
    }
    
    isHairGrowthRelated() {
        // Check if this is a hair growth related quiz
        if (this.answers.product_type !== 'hair') {
            return false;
        }
        
        const hairConcern = this.answers['hair_concern'];
        const hairGrowthConcerns = [
            'Hair growth',
            'Hair fallout',
            'Weak and brittle hair'
        ];
        
        return hairGrowthConcerns.includes(hairConcern);
    }
    
    calculateRecommendation() {
        if (this.answers.product_type === 'hair') {
            return this.calculateHairRecommendation();
        } else if (this.answers.product_type === 'skin') {
            return this.calculateSkinRecommendation();
        }
        return 'lavender'; // Default fallback
    }
    
    calculateHairRecommendation() {
        const texture = this.answers['hair_texture'];
        const scalp = this.answers['hair_scalp'];
        const concern = this.answers['hair_concern'];
        
        // Rosemary Hair Oil
        if (concern === 'Hair growth' || concern === 'Hair fallout') {
            return 'rosemary';
        }
        
        // Olive Hair Oil
        if ((scalp === 'Dry' || texture === 'Normal') && concern === 'Dry/flaky scalp') {
            return 'olive';
        }
        
        // Lemon Hair Oil
        if (scalp === 'Oily' && concern === 'Dry/flaky scalp') {
            return 'lemon';
        }
        
        // Eucalyptus Hair Oil
        if (scalp === 'Oily' && concern === 'Hair growth') {
            return 'eucalyptus';
        }
        
        // Sacha Inchi Hair Oil
        if ((scalp === 'Dry' || texture === 'Normal') && concern === 'Oil control') {
            return 'sacha-inchi';
        }
        
        // Maracuja Hair Oil
        if (scalp === 'Oily' && concern === 'Dryness') {
            return 'maracuja';
        }
        
        // Turmeric Hair Oil
        if ((scalp === 'Dry' || texture === 'Normal') && concern === 'Weak and brittle hair') {
            return 'turmeric';
        }
        
        // Argan Hair Oil
        if ((scalp === 'Dry' || texture === 'Normal') && concern === 'Frizz') {
            return 'argan';
        }
        
        // Peppermint Hair Oil
        if ((scalp === 'Dry' || texture === 'Normal') && concern === 'Hair fallout') {
            return 'peppermint';
        }
        
        // Jojoba Hair Oil
        if (scalp === 'Oily' && concern === 'Hair fallout') {
            return 'jojoba';
        }
        
        // Lavender Hair Oil (maintenance)
        if (concern === 'My hair\'s in pretty good shape, I\'m looking to keep it that way!') {
            return 'lavender';
        }
        
        // Default fallback
        return 'rosemary';
    }
    
    calculateSkinRecommendation() {
        const skinType = this.answers['skin_type'];
        const issues = this.answers['skin_issues'];
        const sensitive = this.answers['skin_sensitivity'];
        
        // Argan Face Oil (sensitive, normal/dry skin)
        if ((skinType === 'Normal' || skinType === 'Dry') && sensitive === 'Yes') {
            return 'argan';
        }
        
        // Almond Face Oil (sensitive, oily/combination skin)
        if ((skinType === 'Oily' || skinType === 'Combination') && sensitive === 'Yes') {
            return 'almond';
        }
        
        // Lavender Face Oil (normal/dry, breakouts, not sensitive)
        if ((skinType === 'Normal' || skinType === 'Dry') && issues === 'Breakouts' && sensitive === 'No') {
            return 'lavender';
        }
        
        // Turmeric Face Oil (oily/combination, breakouts, not sensitive)
        if ((skinType === 'Oily' || skinType === 'Combination') && issues === 'Breakouts' && sensitive === 'No') {
            return 'turmeric';
        }
        
        // Rosemary Face Oil (normal/dry, anti-aging, not sensitive)
        if ((skinType === 'Normal' || skinType === 'Dry') && issues === 'Fine lines and wrinkles' && sensitive === 'No') {
            return 'rosemary';
        }
        
        // Sacha Inchi Face Oil (oily/combination, anti-aging, not sensitive)
        if ((skinType === 'Oily' || skinType === 'Combination') && issues === 'Fine lines and wrinkles' && sensitive === 'No') {
            return 'sacha-inchi';
        }
        
        // Maracuja Face Oil (oily/combination, oiliness)
        if ((skinType === 'Oily' || skinType === 'Combination') && issues === 'Oiliness') {
            return 'maracuja';
        }
        
        // Olive Face Oil (normal/dry, dryness, not sensitive)
        if ((skinType === 'Normal' || skinType === 'Dry') && issues === 'Dryness' && sensitive === 'No') {
            return 'olive';
        }
        
        // Ginger Face Oil (normal/dry, acne scars, not sensitive)
        if ((skinType === 'Normal' || skinType === 'Dry') && issues === 'Acne scars' && sensitive === 'No') {
            return 'ginger';
        }
        
        // Grapeseed Face Oil (normal/dry, uneven tone, not sensitive)
        if ((skinType === 'Normal' || skinType === 'Dry') && issues === 'Uneven skin tone' && sensitive === 'No') {
            return 'grapeseed';
        }
        
        // Lemon Face Oil (oily/combination, uneven tone, not sensitive)
        if ((skinType === 'Oily' || skinType === 'Combination') && issues === 'Uneven skin tone' && sensitive === 'No') {
            return 'lemon';
        }
        
        // Maintenance products
        if (issues === 'My skin\'s in pretty good shape, I\'m looking to keep it that way!') {
            if (skinType === 'Normal' || skinType === 'Dry') {
                return 'lavender';
            } else {
                return 'maracuja';
            }
        }
        
        // Default fallback
        return 'turmeric';
    }
}

// Initialize quiz when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    new Quiz();
});